/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // TextField,
  Button,
  FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  Grid,
  Typography,
  FormHelperText
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { validateAccountData } from '../../../services/common/accountValidateApi'
import { getUser } from '../../../redux/global'
import { successToast } from '../../../common/functions'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import * as constants from '../../../irmlib/src/common/constants'
import { Slider, Box } from '@mui/material'
import { Select } from '../../../irmlib/src/components/FormControls'

const defaultSelectOption = {
  value: constants.defaultSelect,
  label: constants.defaultSelect,
}

const SELECT_COUNTRY = 0


const EditCountrySettingsFields = ({ open, onClose, onAddCustomer, isEditMode = false, editData = null, existingData, confidence, country }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [selectCountry, setSelectCountry] = useState(country)
  const [countryCode, setCountryCode] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [localValue, setLocalValue] = useState(null)
  const [countryList, setCountryList] =useState('')
  const [submitted, setSubmitted] = useState(false)
  const { workerId } = getUser()


  useEffect(() => {
    setLocalValue(confidence)
    setSelectCountry(country)
    if (isEditMode) { setCountryCode(editData.countryCode) }
  }, [confidence,country,open, isEditMode])

  useEffect(async () => {
    const querySnapshot = await localGdeTransactions.getCountries()
    const countriesData = querySnapshot.docs.map(doc => ({
        id: doc.id, 
        ...doc.data(),
        }))
    const usedCountryCodes = existingData?.map(item => item.countryCode) || []
    const filteredData = countriesData.filter(item => {
        if (isEditMode && item.id === countryCode) return true // Keep current country if editing
        return !usedCountryCodes.includes(item.id) // Otherwise, hide if already used
    })

        const countryList = filteredData.map(item => ({
        label: item.countryName,
        value: item.id,
        name: item.countryName,
        }))
        setCountryList(countryList)
  },[existingData, isEditMode])

  const formTemplate = [
    {
      label: 'smartCatalogLocal.selectCountry',
      fieldKey: 'selectCountry',
      defaultValue: selectCountry || constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'smartCatalogLocal.specialChars',
      fieldKey: 'specialChars',
      defaultValue: constants.defaultSelect,
      isRequired: true
    }
  ]

  const setSelectedCountry = (event) => {
    const rawValue = event?.target ? event.target.value : event; 

    //. Find the matching object in your list by EITHER value or label
    const countryObj = countryList.find(c => c.value === rawValue || c.label === rawValue);

    if (countryObj) {
      setCountryCode(countryObj.value)
      setSelectCountry(countryObj.label)
    } else {
      setSelectCountry('');
      setCountryCode('');
    }
  }

  const handleClose = () => {
    setErrorMessage('')
    setSubmitted(false)
    onClose()
  }

  const addEntry = async () => {
    setSubmitted(true)
    if (!selectCountry  || localValue === null) {
    return
  }
    setLoading(true)
    try {
      const payload = {
        confidence: localValue,
        country: selectCountry,
        countryCode: countryCode,
        createdAt: isEditMode ? editData.createdAt : new Date(),
        createdBy: isEditMode ? editData.createdBy : workerId,
        isActive: true,
        updatedAt: new Date(),
        updatedBy: workerId
      }

      const addData = await localGdeTransactions.saveCountrySetting(payload)
      console.log(addData)
      setLoading(false)
      handleClose()
    } catch (error) {
      console.error("Failed to add entry:", error)
      setLoading(false);
    }
  }

  return (
    <Dialog
      open={open} 
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return
        if (reason === 'escapeKeyDown') return
        onClose()
      }}
      PaperProps={{
        style: {
          maxWidth: "650px",
          width: "100%",
        },
      }}
      disableEnforceFocus>
      <DialogTitle>{country === '' ? selectCountry : country}</DialogTitle>
      <DialogContent>
        <Grid item xs={12} sm={4}>
            <FormControl fullWidth margin='normal' error={submitted && !selectCountry}>
              { !isEditMode &&
              <Select
                labelId="country-select-label"
                label="Select Country *"
                value={countryCode}
                onChange={setSelectedCountry}
                items={countryList}
                fieldTemplate={formTemplate[SELECT_COUNTRY]}
                noTranslateItems
                noTranslate={true}
              /> }
              {submitted && !selectCountry && !isEditMode &&
            <FormHelperText>Please select a country</FormHelperText>
            }
            </FormControl>
          </Grid>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
                <Typography fontWeight={600} mb={1} color={submitted && localValue === null ? 'error.main' : 'text.primary'}>
                Quality Check Bypass Threshold *
                </Typography>
            <Slider
                value={localValue ?? 0}
                min={1}
                max={99}
                step={1}
                onChange={(e, v) => setLocalValue(v)}
            />
            {submitted && localValue === null && (
              <Typography color="error" variant="caption">
                  Threshold selection is required
              </Typography>
          )}
            <Typography align="center" fontWeight="bold" fontSize={20}>
            {localValue !== null ? `${localValue}%` : '-- %'}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {errorMessage && (
          <Typography
            key={errorMessage}
            paragraph={true}
            style={{
              fontSize: '16px',
              color: '#FFF',
              backgroundColor: '#db4437',
              width: 'fit-content',
              padding: '4px',
              marginTop: '16px',
              flex: 0.96,
            }}
          >
            {errorMessage}
          </Typography>
        )}
        <Button onClick={handleClose} color='default'>
          {t('dialogs.cancel')}
        </Button>
        <Button
          color='primary'
          variant='contained'
          disabled={loading}
          onClick={addEntry}
        >
          {loading ? (isEditMode ? 'Updating...' : 'Adding...') : (isEditMode ? 'Update' : 'Add')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditCountrySettingsFields